"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.flattenObject = function (obj) {
  var flattened = {};
  Object.keys(obj).forEach(function (key) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      Object.assign(flattened, exports.flattenObject(obj[key]));
    } else {
      flattened[key] = obj[key];
    }
  });
  return flattened;
};

exports.getKeyByValue = function (object, value) {
  return Object.keys(object).find(function (key) {
    return object[key] === value;
  });
};

exports.makeColumnsLayoutArray = function (data) {
  return data.reduce(function (layout, el, idx) {
    if (idx % 2 === 0) {
      layout.push(data.slice(idx, idx + 2));
    }

    return layout;
  }, []);
};